<div class="div-outer-div" *ngIf="image">
  <img [matTooltip]="tooltip" [width]="imageWidth" [height]="imageHeight" [src]="image" />
</div>
